import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "full-wrapper" }
const _hoisted_2 = { class: "main-custom-row" }
const _hoisted_3 = { class: "main-left" }
const _hoisted_4 = { class: "top-info-filters" }
const _hoisted_5 = { class: "custom-row" }
const _hoisted_6 = { class: "dashboard-customer-project mt-25" }
const _hoisted_7 = { class: "dashboard-project-status" }
const _hoisted_8 = { class: "dashboard-chart-2" }
const _hoisted_9 = { class: "custom-row" }
const _hoisted_10 = { class: "dashboard-chart-full" }
const _hoisted_11 = { class: "main-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProjectsList = _resolveComponent("ProjectsList")!
  const _component_ProjectStatus = _resolveComponent("ProjectStatus")!
  const _component_Chart1 = _resolveComponent("Chart1")!
  const _component_Chart2 = _resolveComponent("Chart2")!
  const _component_Chart3 = _resolveComponent("Chart3")!
  const _component_Issues = _resolveComponent("Issues")!
  const _component_Activity = _resolveComponent("Activity")!

  return (_openBlock(), _createElementBlock("div", {
    class: "admin-dashboard-page",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleOutsideClick && _ctx.handleOutsideClick(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h1", null, _toDisplayString(_ctx.constants.DASHBOARD_TEXT), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_ProjectsList)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_ProjectStatus)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_Chart1),
              _createVNode(_component_Chart2)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_Chart3)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_Issues, { ref: "issuesRef" }, null, 512),
          _createVNode(_component_Activity, { ref: "activityRef" }, null, 512)
        ])
      ])
    ])
  ]))
}